import React from 'react';

import { ErrorMessage, InputForm, InputWrapper } from './Input.style';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  errors?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ errors, ...props }, ref) => {
  return (
    <>
      <InputWrapper>
        <InputForm {...props} ref={ref} />
      </InputWrapper>
      {errors && <ErrorMessage>{errors}</ErrorMessage>}
    </>
  );
});

Input.displayName = 'Input';

export default Input;
